/* ============================================
   RKM Mobile Cart Redirect - 2026-10-06 v3
   On mobile (<=749px):
   - Cart icon clicks go to /cart instead of opening drawer
   - After add-to-cart, wait for cart to actually update, then redirect
   Desktop behavior is unchanged.

   v3 changes:
   - Cart icon selector updated for Horizon 4.x: the header cart button
     ([data-testid="cart-drawer-trigger"], aria-controls="cart-drawer")
     sits OUTSIDE <cart-drawer-component>, so the v2 check
     target.closest('cart-drawer-component') never matched and the
     drawer opened instead of redirecting.
   - Cart-update redirect skipped when already on /cart (avoids a
     reload when changing quantities on the cart page).
   ============================================ */

(function() {
  'use strict';

  const MOBILE_BREAKPOINT = 749;
  let pendingRedirect = false;

  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function onCartPage() {
    return window.location.pathname.replace(/\/$/, '') === '/cart';
  }

  // Verify the cart actually has items before redirecting
  // (handles race condition where redirect fires before cart updates server-side)
  function verifyCartAndRedirect() {
    if (pendingRedirect) return;
    pendingRedirect = true;

    fetch('/cart.js', {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    })
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        if (cart && cart.item_count > 0) {
          window.location.href = '/cart';
        } else {
          // Cart not ready yet, try once more after a longer wait
          setTimeout(function() {
            window.location.href = '/cart';
          }, 800);
        }
      })
      .catch(function() {
        // If fetch fails, fall back to a delayed redirect
        setTimeout(function() {
          window.location.href = '/cart';
        }, 800);
      });
  }

  // 1. Intercept cart icon clicks -> go straight to /cart on mobile
  function interceptCartIconClicks() {
    document.addEventListener('click', function(e) {
      if (!isMobile()) return;

      // Header cart button (Horizon 4.x), plus any "open drawer" trigger
      // inside the drawer component as a fallback
      const target = e.target.closest(
        '[data-testid="cart-drawer-trigger"], ' +
        '[aria-controls="cart-drawer"], ' +
        'cart-drawer-component [on\\:click*="/open"]'
      );
      if (!target) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      window.location.href = '/cart';
    }, true);
  }

  // 2. After add-to-cart, verify cart is updated then redirect
  //    Horizon dispatches 'cart:update' after items are added
  function interceptCartUpdates() {
    const cartEvents = ['cart:update', 'cart:refresh', 'cart-update'];

    cartEvents.forEach(function(eventName) {
      document.addEventListener(eventName, function() {
        if (!isMobile()) return;
        if (onCartPage()) return;
        // Small delay then verify cart contents before redirecting
        setTimeout(verifyCartAndRedirect, 200);
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      interceptCartIconClicks();
      interceptCartUpdates();
    });
  } else {
    interceptCartIconClicks();
    interceptCartUpdates();
  }
})();